import React from 'react';
import { Col, Container, Modal, Row } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import { XLg } from 'react-bootstrap-icons';
export default function HeaderModal(props) {
    
    const { title, description, show, setShow, image } = props;
    const handleClose = () => setShow(false);
    return (
        <Modal show={show} onHide={handleClose} centered className='c-modal-acervo' size="lg">
            {/* <Modal.Header closeButton /> */}
            <Modal.Body className='c-modal-acervo-body'>
                <Button variant='link' onClick={handleClose} className='c-modal-acervo-close'>
                    <XLg />
                </Button>
                <Container>
                    <Row>
                        <Col lg={9}  className='c-modal-acervo-content'>
                            <h2 className='c-modal-acervo-title'>{title}</h2>
                            <br/>
                            <p className='c-modal-acervo-description'>{description}</p>
                        </Col>
                        <Col lg={3} style={{background: `url(${image})`}} className='c-modal-acervo-image'/>
                    </Row>
                </Container>
            </Modal.Body>
        </Modal>
    )
}
